<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <h3 class="mb-0">Listado de agentes registrados</h3>
                </div>
                <div class="col-lg-6 col-md-6 d-flex justify-content-end">
                  <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @change="reloadPaginate(1)">
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </select>
                  <input type="text" class="form-control" placeholder="Filtrar por nombre o email" v-model="pagination.search" @keyup="manualSearch">
                </div>
              </div>
            </b-card-header>
            <b-card-body>
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-sm">
                  <thead>
                  <tr>
                    <th class="text-uppercase  font-weight-bolder opacity-7">Name</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">Email</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">Telefono</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">Password</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">Opciones</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, key) in arrayUsers" :key="key">
                    <td>
                      <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.name}}</p>
                    </td>
                    <td>
                      <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.email}}</p>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">{{item.phone}}</p>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">{{item.password_text}}</p>
                    </td>
                    <td>
                      <button class="btn btn-outline-primary btn-sm mb-0" title="Ver detalle" @click="view(item._id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-card-body>
            <b-card-footer class="py-4 d-flex justify-content-between">
              <p class="text-xs font-weight-bold mb-0">total registros: {{pagination.totalRows}}</p>
              <base-pagination @change="reloadPaginate" v-model="pagination.page" :per-page="Number(pagination.limit)" :total="pagination.totalRows"></base-pagination>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui'
import {get} from "@/util/axiosRequest";
import {decrypt, encrypt} from "@/util/encrypt";
import Incognito from "@/assets/incognite.svg";

export default {
  name: 'page-visits-table',
  components: {
    Incognito,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    },
    arrayUsers: [
      {
        name: '',
        email: '',
        phone: '',
        identification: '',
        isActive: '',
        created_at: ''
      },
    ],
    search: '',
    currentPage: 1,
    total: 0
  }),
  mounted() {
    this.getData()
  },
  methods: {
    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },
    getData() {
      this.arrayUsers = []
      get(`users/agents/find-all?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`, null, true).then(({data}) => {
        this.arrayUsers = data.docs
        this.pagination.totalRows = data.count
        this.pagination.page = data.page
        this.pagination.pages = data.pages
      })
    },
    view(id) {
      this.$router.push({name: 'agent-view', params: {id: id}})
    },
  }
}
</script>
<style>
</style>
